<template>
  <header class="header" :class="headerClasses">
    <header-logo class="logo"/>

    <header-navigation class="navigation" />

    <div class="menu">
      <header-requests />
      <header-app-advisor />
      <locale-switcher />
      <header-tray />
    </div>
  </header>
</template>

<script>
  import HeaderLogo       from '@/components/Header/HeaderLogo.vue'
  import HeaderTray       from '@/components/Header/HeaderTray.vue'
  import HeaderNavigation from '@/components/Header/HeaderNavigation'
  import HeaderAppAdvisor from '@/components/Header/HeaderAppAdvisor'
  import HeaderRequests   from '@/components/Header/HeaderRequests'
  import LocaleSwitcher   from '@/components/Common/LocaleSwitcher'

  export default {
    components: {
      HeaderNavigation,
      HeaderAppAdvisor,
      HeaderLogo,
      HeaderTray,
      HeaderRequests,
      LocaleSwitcher
    },

    computed: {
      headerClasses() {
        return {
          'header-mobile': this.$mq === 'mobile'
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .header {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 99;
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    height: $header-height;
    background-color: map.get($colors, primary);
    border-bottom-left-radius: 12px;
    border-bottom-right-radius: 12px;

    .navigation {
      margin: 0 64px;
    }

    .menu {
      display: flex;
      align-items: center;
      justify-content: space-evenly;
      margin-right: 40px;

      * {
        margin: 0 12px;
      }
    }
  }

  .header-mobile {
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;

    .navigation {
      margin: 0 10px;
    }

    .logo {
      margin-left: 18px;
    }

    .menu {
      margin-right: 18px;

      .requests,
      .icon-advisor {
        margin-right: 10px;
      }
    }
  }
</style>
